import { render, staticRenderFns } from "./Security1.container.vue?vue&type=template&id=51938940&scoped=true&"
import script from "./Security1.container.vue?vue&type=script&lang=js&"
export * from "./Security1.container.vue?vue&type=script&lang=js&"
import style0 from "./Security1.container.vue?vue&type=style&index=0&id=51938940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51938940",
  null
  
)

export default component.exports